import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebpushUser, PushSubscriptionInt, DatatableRootObject, DataTablesResponse, Notifi } from '../interfaces/interfaces.index';
import { HTTP_OPTIONS, URL_SERVICIOS } from '../shared/config/config';
import { HubConnection, HubConnectionBuilder, LogLevel } from '@aspnet/signalr';
import { BehaviorSubject } from 'rxjs';
const URL = `${ URL_SERVICIOS }notification`;
@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  socket: HubConnection;
  notificationsModalStatus: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(public http: HttpClient) { }

  callSubscribe = (sub: WebpushUser) => this.http.post(`${URL}/subscribe`, sub, HTTP_OPTIONS);

  unsubscribe = (arg: PushSubscriptionInt) => this.http.post(`${URL}/unsubscribe`, arg, HTTP_OPTIONS);


  startConnection = (userId: number) => {
    this.socket = new HubConnectionBuilder().withUrl(`${URL_SERVICIOS}hub/notification?userId=${userId}`)
      .configureLogging(LogLevel.Information).build();
    return this.socket.start().then(() => console.log('Connection started'))
      .catch(err => console.log('Error while starting connection: ' + err));
  }

  getNotificationsByUser = (id: number) => {
     return this.http.get<Notifi[]>(`${URL}/${id}`, HTTP_OPTIONS)
    };

  getNotifications = () => this.http.get<Notifi[]>(`${URL}`, HTTP_OPTIONS);

  deleteNotification = (notif: Notifi) => this.http.delete(`${URL}/${notif.id}`, HTTP_OPTIONS);

  updateNotification = (notif: Notifi) => this.http.put<Notifi>(`${URL}`, notif, HTTP_OPTIONS);

  markAllAsRead = (userId: number) => this.http.put(`${URL}/mark-all-read/${userId}`, {}, HTTP_OPTIONS);

  createNotification = (notif: Notifi) => this.http.post<Notifi>(`${URL}`, notif, HTTP_OPTIONS);

  getAllDatatables = (tableObj: DatatableRootObject, userId: number) =>
    this.http.post<DataTablesResponse<Notifi>>(`${URL}/datatables?userId=${userId}`, JSON.stringify(tableObj), HTTP_OPTIONS)
}
